import { isSafari } from 'utils/bom-dom-manipulation/is-safari';
import SpringConfigs from 'utils/constants/swarm/spring-configs';

export const assignWebpSupport = () => {
  if (isSafari()) {
    new Promise<boolean>(resolve => {
      const image = new Image();

      image.onerror = function () {
        resolve(false);
      };

      image.onload = function () {
        resolve(image.width === 1);
      };

      image.src =
        'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
    })
      .then(value => {
        SpringConfigs.IS_WEBP_SUPPORTED = value;
      })
      .catch(() => {
        SpringConfigs.IS_WEBP_SUPPORTED = false;
      });
  } else {
    SpringConfigs.IS_WEBP_SUPPORTED = true;
  }
};
